import { am } from './utils';
import httpClient from '@/utils/httpClient';

const LOAD_FILES = am('INVENTION_FILES_LOAD');

export default {
  namespaced: true,
  state: {
    files: [],
    isLoadingFiles: false
  },
  mutations: {
    [LOAD_FILES.STARTED](state) {
      state.isLoadingFiles = true;
      state.files = [];
    },
    [LOAD_FILES.COMPLETED](state, files) {
      state.isLoadingFiles = false;
      state.files = files;
    },
    [LOAD_FILES.FAILED](state) {
      state.isLoadingFiles = false;
    }
  },
  actions: {
    async loadFiles({ commit }, references) {
      commit(LOAD_FILES.STARTED);
      try {
        const files = await httpClient.post('/api/filesmanager/files/getbyreference', {
          reference: references
        });
        commit(LOAD_FILES.COMPLETED, files);
        return files;
      } catch (e) {
        commit(LOAD_FILES.FAILED);
        throw e;
      }
    }
  }
};
